import { graphql } from '@teachino/shared-infrastructure';

export const syncNewSnippetsFromItemTemplateMutation = graphql(`
  mutation SyncNewSnippetsFromItemTemplate($itemId: String!) {
    syncItemWithTemplate(
      itemTemplateSyncInput: { id: $itemId, syncMode: NEW }
    ) {
      done
    }
  }
`);
